import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Subject, firstValueFrom, takeUntil } from "rxjs";
import { Response } from "../../../_shared/models";
import { environment } from "../../../../environments/environment";
import { FuelKpiRequest } from "../../_shared";
import { FuelKpiSummaryResponse } from "../../_shared/models/fuel-kpi-response.model";
import { FuelInsightsResponse } from "../../_shared/models/fuel-insights-response.model";
import { FuelInsightsRequest } from "../../_shared";

@Injectable({
  providedIn: 'root'
})
export class TotalDecreaseService {

  constructor(private http: HttpClient) { }

  public getTotalDecreaseSummary(request: FuelKpiRequest, cancellation: Subject<void>): Promise<Response<FuelKpiSummaryResponse>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fueldashboard/total-decrease-summary`, request).pipe(takeUntil(cancellation)));
  }

  public getFuelDecreaseInsights(request: FuelInsightsRequest, cancellation: Subject<void>): Promise<Response<FuelInsightsResponse[]>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fueldashboardinsights/total-decrease/fuel-decrease-insights`, request).pipe(takeUntil(cancellation)));
  }

  public getDrivingConsumptionDataInsights(request: FuelInsightsRequest, cancellation: Subject<void>): Promise<Response<FuelInsightsResponse[]>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fueldashboardinsights/total-decrease/driving-consumption-insights`, request).pipe(takeUntil(cancellation)));
  }
}